import { motion } from "framer-motion";
import { CHAPTERS } from "../../data/films";

export const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 md:py-36 px-5 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <span className="font-mono text-[11px] tracking-[0.4em] uppercase text-blood">
            (The Manifesto)
          </span>
          <h2 className="mt-4 font-serif text-5xl md:text-7xl leading-[0.9] tracking-tighter text-bone">
            Cinema without <span className="italic">gatekeepers</span>
          </h2>
        </div>

        <div className="border-t border-white/12">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`chapter-${c.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-70px" }}
              transition={{ duration: 0.7, ease: [0.19, 1, 0.22, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 border-b border-white/12 py-10 md:py-14 hover:bg-white/[0.02] transition-colors duration-500"
            >
              <div className="md:col-span-2">
                <span className="font-mono text-5xl md:text-6xl text-blood/90 group-hover:text-blood transition-colors">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-bone">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-5 flex md:items-center">
                <p className="text-base text-muted-foreground leading-relaxed">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
